"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _color = _interopRequireDefault(require("color"));
var _base = _interopRequireDefault(require("./base"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var baseTheme = R.clone(_base["default"]);
var primary = '#FF5F00';
var secondary = '#F79E1B';
var accent = {
  alpha: (0, _color["default"])(secondary).lighten(0.2).string(),
  charlie: (0, _color["default"])(secondary).lighten(0.4).string(),
  delta: (0, _color["default"])(secondary).lighten(0.8).string(),
  foxtrot: (0, _color["default"])(secondary).lighten(0.5).string()
};

// lighten 02 04 05 08
var components = {
  card: {
    bottomBorder: {
      color: primary,
      weight: '10px'
    }
  },
  header: {
    background: '#64625e',
    text: baseTheme.palette.basic.white,
    accentColor: baseTheme.palette.basic.white,
    disabled: baseTheme.palette.accent.sigma
  },
  footer: {
    routes: {
      contact: 'https://www.mastercard.co.uk/en-gb.html',
      support: 'https://www.mastercard.co.uk/en-gb.html',
      privacyPolicy: 'https://www.mastercard.co.uk/en-gb.html',
      terms: 'https://www.mastercard.co.uk/en-gb.html',
      copyright: 'https://www.mastercard.co.uk/en-gb.html',
      facebook: 'https://www.mastercard.co.uk/en-gb.html',
      youtube: 'https://www.mastercard.co.uk/en-gb.html',
      twitter: 'https://twitter.com/uflexreward?lang=en',
      linkedIn: 'https://www.linkedin.com/company/uflexreward/'
    }
  },
  logo: {
    size: '70px'
  }
};
var extra = {
  rewardsCategories: {
    "default": secondary,
    extra: '#050950',
    categories: ['#00a3ad', '#f8a641', '#953bb9', '#bf0d3e', '#98cc02', '#6AE1C4', '#4A4A4A', '#E27370', '#EAEBFE', '#5F618F', '#B580E2', '#F5A623', '#4A11DD', '#AC9E0D', '#DC718A', '#6AE1C4', '#4A4A4A', '#E27370', '#EAEBFE']
  },
  sharesColorMap: {
    vested: primary,
    unvested: secondary
  }
};
baseTheme.palette.primary = primary;
baseTheme.palette.secondary = secondary;
baseTheme.palette.accent = accent;
baseTheme.logoName = 'masterCardLogo';
baseTheme.components = _objectSpread(_objectSpread({}, baseTheme.components), components);
baseTheme.extra = _objectSpread(_objectSpread({}, baseTheme.extra), extra);
baseTheme.name = 'MasterCard Theme';
baseTheme.displayName = 'MasterCard Theme';
baseTheme.identifier = 'masterCard';
var _default = exports["default"] = baseTheme;